import { PetState } from '~/redux/slices/pet-state'
import { getFirebase } from '~/firebase'

import { PetStateResponse, EventData, EventResponse, AvatarResponse } from '~/gamification/types/gamification.types'
import { MathVaultEventModel } from '~/types/math-vault'

export async function updateEventDataToFirebase(eventData: EventData[]): Promise<EventResponse> {
  const { httpsCallable, functions } = await getFirebase()
  return (await httpsCallable(functions, 'updateEventData')(eventData)) as unknown as EventResponse
}

export async function updatePetState(petState: PetState): Promise<PetStateResponse> {
  const { httpsCallable, functions } = await getFirebase()
  return (await httpsCallable(functions, 'updatePetState')(petState)) as unknown as PetStateResponse
}
export async function getHalfPortrait(downloadUrl: string): Promise<AvatarResponse> {
  const { httpsCallable, functions } = await getFirebase()
  return (await httpsCallable(functions, 'avatar')({ downloadUrl })) as unknown as AvatarResponse
}

export async function mathVaultAnswerEventToFirebase(activityData: MathVaultEventModel): Promise<unknown> {
  const { httpsCallable, functions } = await getFirebase()
  return (await httpsCallable(functions, 'mathVaultAnswerEvent')(activityData)) as unknown
}
